export enum StationStartItemNo {
  s0 = 'stationItems-starts-00000000',
  s1 = 'stationItems-starts-00000001',
  s2 = 'stationItems-starts-00000002',
  s3 = 'stationItems-starts-00000003',
  s4 = 'stationItems-starts-00000004',
  s5 = 'stationItems-starts-00000005',
  s6 = 'stationItems-starts-00000006',
  s7 = 'stationItems-starts-00000007',
  s8 = 'stationItems-starts-00000008',
  s9 = 'stationItems-starts-00000009',
  s10 = 'stationItems-starts-00000010',
  s11 = 'stationItems-starts-00000011',
  s12 = 'stationItems-starts-00000012',
  s13 = 'stationItems-starts-00000013',
  s14 = 'stationItems-starts-00000014',
  s15 = 'stationItems-starts-00000015',
  s16 = 'stationItems-starts-00000016',
  s17 = 'stationItems-starts-00000017',
  s18 = 'stationItems-starts-00000018',
  s19 = 'stationItems-starts-00000019',
  s20 = 'stationItems-starts-00000020',
}

export enum StationGoalItemNo {
  s0 = 'stationItems-goals-00000000',
  s1 = 'stationItems-goals-00000001',
  s2 = 'stationItems-goals-00000002',
  s3 = 'stationItems-goals-00000003',
  s4 = 'stationItems-goals-00000004',
  s5 = 'stationItems-goals-00000005',
  s6 = 'stationItems-goals-00000006',
  s7 = 'stationItems-goals-00000007',
  s8 = 'stationItems-goals-00000008',
  s9 = 'stationItems-goals-00000009',
  s10 = 'stationItems-goals-00000010',
  s11 = 'stationItems-goals-00000011',
  s12 = 'stationItems-goals-00000012',
  s13 = 'stationItems-goals-00000013',
  s14 = 'stationItems-goals-00000014',
  s15 = 'stationItems-goals-00000015',
  s16 = 'stationItems-goals-00000016',
  s17 = 'stationItems-goals-00000017',
  s18 = 'stationItems-goals-00000018',
  s19 = 'stationItems-goals-00000019',
  s20 = 'stationItems-goals-00000020',
}

export enum StationEmptyItemNo {
  s1 = 'stationItems-empties-00000001',
  s2 = 'stationItems-empties-00000002',
  s3 = 'stationItems-empties-00000003',
  s4 = 'stationItems-empties-00000004',
  s5 = 'stationItems-empties-00000005',
  s6 = 'stationItems-empties-00000006',
  s7 = 'stationItems-empties-00000007',
  s8 = 'stationItems-empties-00000008',
  s9 = 'stationItems-empties-00000009',
  s10 = 'stationItems-empties-00000010',
  s11 = 'stationItems-empties-00000011',
  s12 = 'stationItems-empties-00000012',
  s13 = 'stationItems-empties-00000013',
  s14 = 'stationItems-empties-00000014',
  s15 = 'stationItems-empties-00000015',
  s16 = 'stationItems-empties-00000016',
  s17 = 'stationItems-empties-00000017',
  s18 = 'stationItems-empties-00000018',
  s19 = 'stationItems-empties-00000019',
  s20 = 'stationItems-empties-00000020',
}

export enum StationGameItemNo {
  s0 = 'stationItems-games-00000000',
  s1 = 'stationItems-games-00000001',
  s2 = 'stationItems-games-00000002',
  s3 = 'stationItems-games-00000003',
  s4 = 'stationItems-games-00000004',
  s5 = 'stationItems-games-00000005',
  s6 = 'stationItems-games-00000006',
  s7 = 'stationItems-games-00000007',
  s8 = 'stationItems-games-00000008',
  s9 = 'stationItems-games-00000009',
  s10 = 'stationItems-games-00000010',
  s11 = 'stationItems-games-00000011',
  s12 = 'stationItems-games-00000012',
  s13 = 'stationItems-games-00000013',
  s14 = 'stationItems-games-00000014',
  s15 = 'stationItems-games-00000015',
  s16 = 'stationItems-games-00000016',
  s17 = 'stationItems-games-00000017',
  s18 = 'stationItems-games-00000018',
  s19 = 'stationItems-games-00000019',
  s20 = 'stationItems-games-00000020',
}

export enum StationSlideshowItemNo {
  s1 = 'stationItems-slideshows-00000001',
  s2 = 'stationItems-slideshows-00000002',
  s3 = 'stationItems-slideshows-00000003',
  s4 = 'stationItems-slideshows-00000004',
  s5 = 'stationItems-slideshows-00000005',
  s6 = 'stationItems-slideshows-00000006',
  s7 = 'stationItems-slideshows-00000007',
  s8 = 'stationItems-slideshows-00000008',
  s9 = 'stationItems-slideshows-00000009',
  s10 = 'stationItems-slideshows-00000010',
  s11 = 'stationItems-slideshows-00000011',
  s12 = 'stationItems-slideshows-00000012',
  s13 = 'stationItems-slideshows-00000013',
  s14 = 'stationItems-slideshows-00000014',
  s15 = 'stationItems-slideshows-00000015',
  s16 = 'stationItems-slideshows-00000016',
  s17 = 'stationItems-slideshows-00000017',
  s18 = 'stationItems-slideshows-00000018',
  s19 = 'stationItems-slideshows-00000019',
  s20 = 'stationItems-slideshows-00000020',
}

export enum StationRewardItemNo {
  s1 = 'stationItems-rewards-00000001',
  s2 = 'stationItems-rewards-00000002',
  s3 = 'stationItems-rewards-00000003',
  s4 = 'stationItems-rewards-00000004',
  s5 = 'stationItems-rewards-00000005',
  s6 = 'stationItems-rewards-00000006',
  s7 = 'stationItems-rewards-00000007',
  s8 = 'stationItems-rewards-00000008',
  s9 = 'stationItems-rewards-00000009',
  s10 = 'stationItems-rewards-00000010',
  s11 = 'stationItems-rewards-00000011',
  s12 = 'stationItems-rewards-00000012',
  s13 = 'stationItems-rewards-00000013',
  s14 = 'stationItems-rewards-00000014',
  s15 = 'stationItems-rewards-00000015',
  s16 = 'stationItems-rewards-00000016',
  s17 = 'stationItems-rewards-00000017',
  s18 = 'stationItems-rewards-00000018',
  s19 = 'stationItems-rewards-00000019',
  s20 = 'stationItems-rewards-00000020',
}

export enum StationRuleItemNo {
  s1 = 'stationItems-rules-00000001',
  s2 = 'stationItems-rules-00000002',
  s3 = 'stationItems-rules-00000003',
  s4 = 'stationItems-rules-00000004',
  s5 = 'stationItems-rules-00000005',
  s6 = 'stationItems-rules-00000006',
  s7 = 'stationItems-rules-00000007',
  s8 = 'stationItems-rules-00000008',
  s9 = 'stationItems-rules-00000009',
  s10 = 'stationItems-rules-00000010',
  s11 = 'stationItems-rules-00000011',
  s12 = 'stationItems-rules-00000012',
  s13 = 'stationItems-rules-00000013',
  s14 = 'stationItems-rules-00000014',
  s15 = 'stationItems-rules-00000015',
  s16 = 'stationItems-rules-00000016',
  s17 = 'stationItems-rules-00000017',
  s18 = 'stationItems-rules-00000018',
  s19 = 'stationItems-rules-00000019',
  s20 = 'stationItems-rules-00000020',
}

export enum StationMiniChallengeItemNo {
  s0 = 'stationItems-miniChallenges-00000000',
  s1 = 'stationItems-miniChallenges-00000001',
  s2 = 'stationItems-miniChallenges-00000002',
  s3 = 'stationItems-miniChallenges-00000003',
  s4 = 'stationItems-miniChallenges-00000004',
  s5 = 'stationItems-miniChallenges-00000005',
  s6 = 'stationItems-miniChallenges-00000006',
  s7 = 'stationItems-miniChallenges-00000007',
  s8 = 'stationItems-miniChallenges-00000008',
  s9 = 'stationItems-miniChallenges-00000009',
  s10 = 'stationItems-miniChallenges-00000010',
  s11 = 'stationItems-miniChallenges-00000011',
  s12 = 'stationItems-miniChallenges-00000012',
  s13 = 'stationItems-miniChallenges-00000013',
  s14 = 'stationItems-miniChallenges-00000014',
  s15 = 'stationItems-miniChallenges-00000015',
  s16 = 'stationItems-miniChallenges-00000016',
  s17 = 'stationItems-miniChallenges-00000017',
  s18 = 'stationItems-miniChallenges-00000018',
  s19 = 'stationItems-miniChallenges-00000019',
  s20 = 'stationItems-miniChallenges-00000020',
}

export enum StationSuperChallengeItemNo {
  s0 = 'stationItems-superChallenges-00000000',
  s1 = 'stationItems-superChallenges-00000001',
  s2 = 'stationItems-superChallenges-00000002',
  s3 = 'stationItems-superChallenges-00000003',
  s4 = 'stationItems-superChallenges-00000004',
  s5 = 'stationItems-superChallenges-00000005',
  s6 = 'stationItems-superChallenges-00000006',
  s7 = 'stationItems-superChallenges-00000007',
  s8 = 'stationItems-superChallenges-00000008',
  s9 = 'stationItems-superChallenges-00000009',
  s10 = 'stationItems-superChallenges-00000010',
  s11 = 'stationItems-superChallenges-00000011',
  s12 = 'stationItems-superChallenges-00000012',
  s13 = 'stationItems-superChallenges-00000013',
  s14 = 'stationItems-superChallenges-00000014',
  s15 = 'stationItems-superChallenges-00000015',
  s16 = 'stationItems-superChallenges-00000016',
  s17 = 'stationItems-superChallenges-00000017',
  s18 = 'stationItems-superChallenges-00000018',
  s19 = 'stationItems-superChallenges-00000019',
  s20 = 'stationItems-superChallenges-00000020',
}

export enum StationTutorGameItemNo {
  s0 = 'stationItems-assistedGames-0000000',
  s1 = 'stationItems-assistedGames-00000001',
  s2 = 'stationItems-assistedGames-00000002',
  s3 = 'stationItems-assistedGames-00000003',
  s4 = 'stationItems-assistedGames-00000004',
  s5 = 'stationItems-assistedGames-00000005',
  s6 = 'stationItems-assistedGames-00000006',
  s7 = 'stationItems-assistedGames-00000007',
  s8 = 'stationItems-assistedGames-00000008',
  s9 = 'stationItems-assistedGames-00000009',
  s10 = 'stationItems-assistedGames-00000010',
  s11 = 'stationItems-assistedGames-00000011',
  s12 = 'stationItems-assistedGames-00000012',
  s13 = 'stationItems-assistedGames-00000013',
  s14 = 'stationItems-assistedGames-00000014',
  s15 = 'stationItems-assistedGames-00000015',
  s16 = 'stationItems-assistedGames-00000016',
  s17 = 'stationItems-assistedGames-00000017',
  s18 = 'stationItems-assistedGames-00000018',
  s19 = 'stationItems-assistedGames-00000019',
  s20 = 'stationItems-assistedGames-00000020',
}

export enum StationDoorItemNo {
  s1 = 'stationItems-doors-00000001',
  s2 = 'stationItems-doors-00000002',
  s3 = 'stationItems-doors-00000003',
  s4 = 'stationItems-doors-00000004',
  s5 = 'stationItems-doors-00000005',
  s6 = 'stationItems-doors-00000006',
  s7 = 'stationItems-doors-00000007',
  s8 = 'stationItems-doors-00000008',
  s9 = 'stationItems-doors-00000009',
  s10 = 'stationItems-doors-00000010',
  s11 = 'stationItems-doors-00000011',
  s12 = 'stationItems-doors-00000012',
  s13 = 'stationItems-doors-00000013',
  s14 = 'stationItems-doors-00000014',
  s15 = 'stationItems-doors-00000015',
  s16 = 'stationItems-doors-00000016',
  s17 = 'stationItems-doors-00000017',
  s18 = 'stationItems-doors-00000018',
  s19 = 'stationItems-doors-00000019',
  s20 = 'stationItems-doors-00000020',
}

export enum StationSeriesNo {
  s0 = 'station-series-00000000',
  s1 = 'station-series-00000001',
  s2 = 'station-series-00000002',
  s3 = 'station-series-00000003',
  s4 = 'station-series-00000004',
  s5 = 'station-series-00000005',
  s6 = 'station-series-00000006',
  s7 = 'station-series-00000007',
  s8 = 'station-series-00000008',
  s9 = 'station-series-00000009',
  s10 = 'station-series-00000010',
  s11 = 'station-series-00000011',
  s12 = 'station-series-00000012',
  s13 = 'station-series-00000013',
  s14 = 'station-series-00000014',
  s15 = 'station-series-00000015',
  s16 = 'station-series-00000016',
  s17 = 'station-series-00000017',
  s18 = 'station-series-00000018',
  s19 = 'station-series-00000019',
  s20 = 'station-series-00000020',
}

export enum StationType {
  Start = 'start',
  Goal = 'goal',
  Reward = 'reward',
  // Empty = 'empty',
  Game = 'game',
  // Slideshow = 'slideshow',
  AssistedGame = 'assistedGame',
  PathChallenge = 'pathChallenge',
  SuperChallenge = 'superChallenge',
}

export enum Rarity {
  N = 'N',
  R = 'R',
  SR = 'SR',
  SSR = 'SSR',
  UR = 'UR',
}

export type StationItemNo =
  | StationStartItemNo
  | StationGoalItemNo
  | StationEmptyItemNo
  | StationGameItemNo
  | StationSlideshowItemNo
  | StationRewardItemNo
  | StationRuleItemNo
  | StationMiniChallengeItemNo
  | StationSuperChallengeItemNo
  | StationTutorGameItemNo
  | StationDoorItemNo;

export type StationVisual = {
  filePrefix: string;
  frameCount: number;
};

export type StationItem = {
  itemId: StationItemNo;
  category: string;
  subcategory: string;
  type: string;
  set: string;
  index: number;
  isVisible: boolean;
  visual: StationVisual;
  rewardSource: string;
  value: number;
  rarity: Rarity;
  seriesId: StationSeriesNo;
};
